import { render, staticRenderFns } from "./UserCompany.vue?vue&type=template&id=37639760"
import script from "./UserCompany.vue?vue&type=script&lang=js"
export * from "./UserCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports